module.exports = require('./helpers/bundle-url').getBundleURL('6XXAY') + "assets/images/close.94a12208.svg";